import beatTapesRepository from  "./beat-tapes-repository.js"
import ServiceRepository from './service-repository.js'

export default {
    mixins: [ServiceRepository, beatTapesRepository],
	methods: {
        addDiscoverPlaylistOnce () {
            this.$store.state.playlistManager.emptyPagePlaylist()
            this.$store.commit('clearDiscoverPlaylist')

            if (this.page.featured.primary.show || this.page.featured.secondary.show) {
                this.featuredRequest()
            }

            if (this.page.new.show) {
                this.newBeatsRequest()
            }

            if (this.page.trending.show) {
                this.trendingBeatsRequest()
            }

            if (this.page.soundkits.show) {
                this.soundkitsRequest()
            }

            if (this.page.songs.show) {
                this.songsRequest()
            }

            if (this.page.beattapes.show) {
                this.beattapesRequest()
            }

            if (this.page.services.show) {
                this.servicesRequest()
            }

            setTimeout(() => {
                this.$store.commit('discoverPageInitialLoad', {load: true})
            }, 500)

        },
		userBeatsQuery (params = {}, type = 'beats') {
			return this.$http.get(`${ab.apiUrl}/users/${ab.user.id}/${type}`, params)
		},
        searchBeatsQuery (params = {}) {
            return this.$http.get(`${ab.apiUrl}/beats/search`, params)
        },
        featuredRequest () {
            Promise.all([this.userBeatsQuery(this.primaryParams()), this.userBeatsQuery(this.secondaryParams())])
            .then((response) => {
                if (this.page.featured.primary.show) {
                    this.$store.commit('addToDiscoverPlaylist', {key: 'primary', value: response[0].data.items})
                }

                if (this.page.featured.secondary.show) {
                    this.$store.commit('addToDiscoverPlaylist', {key: 'secondary', value: response[1].data.items})
                }

            }).catch(err => console.log(err))
        },
        newBeatsRequest() {
            this.userBeatsQuery(this.newBeatsParams()).then((response) => {
                this.$store.commit('addToDiscoverPlaylist', {key: 'newBeats', value: response.data.items});
            })
        },
        trendingBeatsRequest() {
            this.searchBeatsQuery(this.trendingBeatsParams()).then((response) => {
                this.$store.commit('addToDiscoverPlaylist', {key: 'trendingBeats', value: response.data.items});
            })
        },
        soundkitsRequest () {
            this.userBeatsQuery(this.kitsParams(), 'kits').then((response) => {
                this.$store.commit('addToDiscoverPlaylist', {key: 'soundkits', value: response.data.items});
            })
        },
        songsRequest () {
            this.userBeatsQuery(this.songsParams(), 'songs').then((response) => {
                this.$store.commit('addToDiscoverPlaylist', {key: 'songs', value: response.data.items});
            })
        },
        servicesRequest () {
            this.getUserServices(1, 3 , {
                selection: this.page.services.items.join(',') || undefined
            }).then((response) => {
                this.$store.commit('addToDiscoverPlaylist', {key: 'services', value: response.data.items});
            })
        },
        async beattapesRequest () {
            const selection = this.$store.state.currentConfig.homePage?.beattapes?.items
            const selectedItems = selection.join(",")
            let response = null
            if(selectedItems) response = await this.getAllSelectedItems(selectedItems)
            else response = await this.getDefaultBeatTapes()
            this.$store.commit('addToDiscoverPlaylist', {key: 'beattapes', value: response.data.items})

        },
        primaryParams () {
            return {
                params: {
                    featured: this.page.featured.primary.items,
                    api_token: ab.token,
                    limit: 4,
                }
            }
        },
        secondaryParams () {
            var params = this.primaryParams()
            params.params.featured =  this.page.featured.secondary.items
            return params
        },
        newBeatsParams () {
            return { params: {user_id: ab.user.id, order: 'newest', limit: 8, expand: 'tags'} }
        },
        trendingBeatsParams () {
            return { params: {order: 'plays_7', limit: 4, user_id: this.user.id} }
        },
        kitsParams () {
               return  { params: { featured: this.page.soundkits.items, limit: 3, api_token: ab.token} }
        },
        songsParams () {
               return  { params: { featured: this.page.songs.items, limit: 4, api_token: ab.token} }
        },
        beattapesParams () {
                return  { params: { featured: this.page.beattapes.items, limit: 4, api_token: ab.token} }
        }
	}
}
